// icons
import { MdViewKanban } from 'react-icons/md';

const kanban = {
  id: 'kanban-group',
  type: 'group',
  roles: [1],
  breadcrumbs: false,
  children: [
    {
      id: 'kanban',
      title: 'Kanban',
      type: 'item',
      breadcrumbs: false,
      icon: MdViewKanban,
      url: '/kanban'
    }
  ]
};

export default kanban;
